define('widgets/emails',[
	'jquery',
	'widgets/slides',
	'widgets/frames',
	'lib/jquery-ui/core',
], function ($, slides) {

	return $.widget('muse.emails', slides, {

		options: {
			shortcuts: true,
			className: null,
			resize: true
		},

		_create: function () {

			this._super();

			this.$frames = this.element.find('.frames').frames();

			this._on({
				'emailsbeforeresize': $.proxy(this, 'beforeResize'),
				'mousedown .size':  $.proxy(this, 'onClickSize')
			});

			$.subscribe('sizeUpdate', $.proxy(this, 'resize'));

			return this;

		},

		beforeResize: function () {

			this.$wrap.addClass('rendering');
			this.$frames.frames('render');
			this.$wrap.removeClass('rendering');

		},

		browse: function (direction) {

			var $target, $frame;

			if (!this.$current.hasClass('email'))
				return this._super(direction);

			direction = direction || 'next';
			$target = this._frames('getCurrent')[direction]('.frame');

			// if (!$target.length)
			// 	return this._super(direction);

			if ($target.length)
				return this.goTo($target);

			$target = this.$current[direction]('.slide');

			if (!$target.length)
				return;

			if (direction != 'next') {
				$frame = $target.find('.frame:last');
				$target = $frame.length ? $frame : $target;
			}

			return this.goTo($target);

		},

		goTo: function ($target) {

			var $parent,
				left;

			if (!$target.hasClass('frame'))
				return this._super($target);

			$parent = $target.closest('.slide');

			left = -$parent.position().left;
			left -= ($target.offset().left - $parent.find('.frame').offset().left);

			// left = this.$wrap.offset().left - $parent.offset().left;
			// left -= $target.position().left;

			this._super(left);
			this.setCurrent($parent, $target);

			return this;

		},

		hasPrev: function () {

			if (!this.$current.hasClass('email')) return this._super();
			return this._frames('hasPrev') || this._super();

		},

		hasNext: function () {

			if (!this.$current.hasClass('email')) return this._super();
			return this._frames('hasNext') || this._super();

		},

		// frames proxy
		_frames: function () {

			if (!this._$frames.is(":data('muse-frames')"))
				return false;

			return this._$frames.frames.apply(this._$frames, arguments);

		},

		setCurrent: function ($current, $frame) {

			this._super($current);
			this._$frames = this.$current.find('.frames');

			if ($current)
				this.element.toggleClass('email-layout', !$current.hasClass('title'));

			if (this.$current.hasClass('email'))
				this._frames('setCurrent', $frame);

		},

		checkPosition: function () {

			var offset = 0,
				$frames = this.$current.find('.frame'),
				$frame = $frames.first(),
				min = $frame.length ? $frame.offset().left : 0,
				tolerance = this.option('tolerance');

			this._super();

			if (!$frames.length) return;

			offset = this.element[0].scrollLeft - this.$current.position().left;
			$frames.each(function () {

				$el = $(this);
				if (($el.offset().left - min) <= (offset - tolerance)) $frame = $el;

			});

			this.setCurrent(this.$current, $frame);

		},

		onClickSize: function (e) {

			var $el = $(e.currentTarget).closest('.email');
			this.setCurrent($el);

		}

	});

});
